import React from "react";
import { Link } from "react-router-dom";

const SupplementsTable = ({ supplement_details }) => {
  return (
    <div className="overflow-x-auto">
      <h2 className="text-2xl text-mv-darkblue uppercase font-bold py-4">
        {" "}
        Enhancement Summary{" "}
      </h2>
      {supplement_details.length > 0 ? (
        <table className="min-w-full bg-white">
          <thead>
            <tr>
              <th className="py-2 text-left px-4 border border-gray-300">
                Sailing Enhancements
              </th>
              <th className="py-2 text-center  px-4 border border-gray-300">
                Quantity
              </th>
            </tr>
          </thead>
          <tbody>
            {supplement_details.map((supplement) => (
              <tr key={supplement.id + supplement.guest_id}>
                <td className="py-2 text-left px-4 border border-gray-300">
                  {supplement.title}
                </td>
                <td className="py-2 text-center  px-4 border border-gray-300">
                  {supplement.quantity}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="text-center text-mv-darkblue font-semibold">
          No supplements added <br />
          <Link
            className="text-mv-darkblue underline font-semibold hover:text-mv-darkblue"
            to={`/?currentTab=Enhance Sailing`}
          >
            Add Now
          </Link>
        </div>
      )}
    </div>
  );
};

export default SupplementsTable;
